import React from "react";
import {
  Box,
  Container,
  CssBaseline,
  Grid,
  Typography,
} from "@material-ui/core";
export const NotFound = () => {
  return (
    <Container component="main">
      <CssBaseline />
      <Grid container direction="column" alignItems="center" mt={5}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography variant="h1" component="h1" gutterBottom>
            404
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography>Whoops</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography>
            We couldn't find the site you are looking for.
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};
